import axios from 'axios'

import { reatailmediaApi as baseAPI } from '../api'

export const baseURL = `${baseAPI}/publisher`

/**
 * VIEW
 * Retorna dados do publisher com opção de retornar dados da conta
 */
export const getPublisherService = ({
  url: { id },
  params
}: GetPublisherResquest) =>
  axios.get<GetPublisherResponse>(`${baseURL}/${id}`, { params })

/**
 * Este endpoint retorna todos os publishers existentes na base da VTEX
 * que estejam ativos e com a flag allow_offsite = false.
 * A lista prioriza os publishers vinculados à VTEX Ads Network,
 * exibindo-os primeiro, em ordem crescente.
 * Em seguida, serão listados os demais publishers que não fazem parte da rede,
 * também em ordem crescente.
 */
export const getPublishersOnsiteKey = 'getPublishersOnsite'
export const getPublishersOnsite = (params: ListPublisherOnsiteRequest) =>
  axios.get<ListPublisherOnsiteResponse>(`${baseURL}/onsite`, { params })

export const getPublisherDestinationSettingsKey =
  'getPublisherDestinationSettings'

export const getPublisherDestinationSettingsService = () =>
  axios.get<GetPublisherDestinationSettingsResponse>(
    `${baseURL}/destination-settings`
  )

export const getPublisherDestinationCampaignsService = (params: {
  page: number
  quantity: number
}) =>
  axios.get<GetPublisherDestinationCampaignsResponse>(
    `${baseURL}/destination-campaigns`,
    { params }
  )

export const updatePublisherDestinationSettingsService = (
  body: UpdatePublisherDestinationSettingsRequest
) => axios.put(`${baseURL}/destination-settings`, body)

/**
 * LIST
 * Lista publishers com filtros opcionais.
 *
 * `GET /publisher/:id` busca por `publishers.id`, e o token da sessão só
 * carrega `current_account_id`. Para resolver o publisher da conta logada é
 * preciso filtrar por `account_id` — mesmo caminho usado pelo BFF em
 * `vinculateAccountToPublisherOrAdvertiser`.
 */
interface ListPublisherRequest extends PaginationRequest {
  /** Não declarado no DTO da API; filtra porque o validator não usa whitelist. */
  account_id?: string
  id?: string[]
  name?: string
}

export const listPublisherService = (params: ListPublisherRequest = {}) =>
  axios.get<GetPublisherResponse[]>(baseURL, { params })
